export class OrderStatus {
  static WithdrawOrderStatus = {
    Reviewing: 'Reviewing',
    Transferring: 'Transferring',
    Rejected: 'Rejected',
    Success: 'Success',
  };
}
